import {Injectable} from '@angular/core';
import {forkJoin, from, Observable} from "rxjs";
import {hunaParseFileName} from "./global-variables.service";
import  Parse from 'parse';

@Injectable({
    providedIn: 'root'
})
export class ImageService {

    constructor() {
    }

    private maxDimension: number = 2000;

    public compressImage(src: string) {
        return new Promise((res, rej) => {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                const elem = document.createElement('canvas');
                if (img.width > this.maxDimension || img.height > this.maxDimension) {
                    if (img.width > img.height) {
                        const ratio = img.height / img.width;
                        elem.width = this.maxDimension;
                        elem.height = this.maxDimension * ratio;
                    } else {
                        const ratio = img.width / img.height;
                        elem.width = this.maxDimension * ratio;
                        elem.height = this.maxDimension;
                    }
                } else {
                    elem.width = img.width;
                    elem.height = img.height;
                }
                const ctx = elem.getContext('2d');
                ctx?.drawImage(img, 0, 0, elem.width, elem.height);
                const data = ctx?.canvas.toDataURL('image/jpeg', 0.7);
                res(data);
            };
            img.onerror = error => rej(error);
        })
    }

    getBase64FromParseFile$(url: string): Observable<string | null> {
        return new Observable(observer => {
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                        observer.next(reader.result as string);
                        observer.complete();
                    };
                    reader.onerror = (error) => {
                        observer.error(error);
                    };
                })
                .catch(error => observer.error(error));
        });
    }

    getBase64(file: File): Observable<{ base64: string, name: string }> {
        return new Observable((subscriber) => {
            const fileUploadControl = file;
            if (fileUploadControl) {
                const fileRead = fileUploadControl;
                const name = fileUploadControl.name;
                const reader = new FileReader();
                reader.onloadend = (e: ProgressEvent) => {
                    const base64 = (e.target as FileReader).result as any;
                    subscriber.next({base64, name});
                    subscriber.complete();
                    subscriber.unsubscribe();
                };
                reader.onerror = (e) => {
                    subscriber.error(e);
                    subscriber.complete();
                    subscriber.unsubscribe();
                }
                reader.readAsDataURL(fileRead);
            }
        })
    }

    getBases64(files: File[]): Observable<{ base64: string, name: string }[]> {
        const allFiles: Observable<any> [] = [];
        files.forEach(
            file => {
                allFiles.push(this.getBase64(file))
            }
        )
        return forkJoin(allFiles) as Observable<{ base64: string, name: string }[]>
    }


    getParseFile(file: File, name: string | undefined = undefined): Observable<Parse.File> {
        return new Observable((subscriber) => {
            const fileUploadControl = file;
            if (fileUploadControl) {
                const fileRead = fileUploadControl;
                if (name == null) {
                    name = fileUploadControl.name
                }
                const reader = new FileReader();
                reader.onloadend = (e) => {
                    if (e.target) {
                        const base64 = e.target.result as any;
                        const parseFile = new Parse.File(hunaParseFileName(name as string), {base64: base64});
                        subscriber.next(parseFile);
                    }
                    subscriber.complete();
                    subscriber.unsubscribe();
                };
                reader.onerror = (error) => {
                    subscriber.error(error);
                    subscriber.complete();
                    subscriber.unsubscribe();
                }
                reader.readAsDataURL(fileRead);
            }
        })
    }

    getHTMLImage$(url: string): Observable<HTMLImageElement> {
        return new Observable<any>(subscriber => {
            const image = new Image()
            image.src = url
            image.onload = () => {
                subscriber.next(image)
                subscriber.complete()
            }
            image.onerror = () => {
                subscriber.error()
                subscriber.complete()
            }
        })
    }
}
